import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const LtiBlockLinkWrapper = styled.div<{
  isSelected: boolean;
  isError: boolean;
}>`
  width: 100%;
  height: 64px;
  border-radius: ${theme.borderRadius.medium};
  border: ${({ isSelected, isError }) => {
    if (isSelected) {
      return `1px solid ${theme.color.designSystem.purple70}`;
    }
    if (isError) {
      return `1px solid ${theme.color.designSystem.error}`;
    }
    return `1px solid ${theme.color.designSystem.grey20}`;
  }};
  display: flex;
  align-items: center;
  margin-top: ${theme.spacing.small};
  margin-bottom: ${theme.spacing.small};
  ${({ isError }) =>
    isError && `background-color: ${theme.color.designSystem.grey20}`}};
`;

export const ButtonWrapper = styled.button<{ isSelected: boolean }>`
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  border: none;
  background-color: ${({ isSelected }) =>
    isSelected
      ? theme.color.designSystem.purple30
      : theme.color.designSystem.grey20};
  cursor: pointer;
`;

export const TitleWrapper = styled.span`
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin-left: 8px;
`;

export const ErrorWrapper = styled.div`
  padding: 12px 0 10px 0;
  display: flex;
  margin-left: 9px;
  width: 100%;
  flex-direction: column;
`;

export const ErrorContainer = styled.div`
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  svg {
    fill: ${theme.color.designSystem.error};
  }
  margin-left: 6px;
  display: flex;
  align-items: center;
  justify-content: left;
`;

export const ErrorTitle = styled.div`
  margin-left: 6px;
`;

export const Loader = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 9px;
  width: 100%;
`;

export const RetryContainer = styled.span`
  margin-left: 31px;
`;

export const ImageWrapper = styled.span`
  padding-left: 4px;
  width: 27px;
`;
